import { useState, useRef, useEffect } from 'react';
import { FiSun } from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';
import styles from './ThemeSelector.module.css';

const SWATCHES = {
  saffron:    '#e65100',
  'blue-dark': '#1565c0',
  emerald:    '#2e7d32',
  black:      '#111111',
};

const ThemeSelector = () => {
  const { theme, setTheme, themes } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className={styles.wrapper} ref={ref}>
      <button className={styles.trigger} onClick={() => setOpen((o) => !o)} title="Change theme">
        <FiSun size={14} />
      </button>

      {open && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>Theme</div>
          {themes.map((t) => (
            <div
              key={t.id}
              className={`${styles.option} ${theme === t.id ? styles.active : ''}`}
              onClick={() => { setTheme(t.id); setOpen(false); }}
            >
              <div className={styles.swatch} style={{ background: SWATCHES[t.id] }} />
              <span className={styles.optionLabel}>{t.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeSelector;
